export const colors = {
	white				: '#FFFFFF',
	lightestGray    	: '#EEF2F5', //Background
	lighterGray			: '#EFF3F4', //Borders (Input / Nav)
	lightGray 			: '#E5E5E5',
	gray            	: '#F0ECE9',
	darkGray        	: '#5E5E5E',
	darkerGray      	: '#555555',
	black           	: '#000000',

	red					: '#AA1F24',
	lightRed 			: '#CA454F',
}

export const layout = {
	outerGutter 	: 50,
	gutterSize     	: 30,
}



// WEBPACK FOOTER //
// ./src/config/styles.js